import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from '../include/chainesLocales.js';

class Bienvenue extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                titre: "",
                contenu: ""
            }
        };
    }

    get labels() {
        return chainesLocales['Bienvenue'][this.props.lang];
    }

    render() {
        const formlBienvn = this.props.config[`FORML_BIENVN_${this.props.lang}`];

        return (
            <div className="Bienvenue">
                <h1 className="text-left" dangerouslySetInnerHTML={{__html: formlBienvn || this.labels.title + " <em>" + this.props.config[`NM_COLCT_${this.props.lang}`] + "</em>"}} />
                {
                    this.getLogoData() !== false ? 
                    <div className="row">
                        {
                            this.renderLogo()
                        }
                        <div className="col-xs-12 col-lg-8 text-justify">
                            <p dangerouslySetInnerHTML={{ __html: this.props.config[`MES_BIENVN_${this.props.lang}`] }}></p>
                        </div>
                    </div> :
                    <div className="col-xs-12 text-justify">
                        <p dangerouslySetInnerHTML={{ __html: this.props.config[`MES_BIENVN_${this.props.lang}`] }}></p>
                    </div>
                }
                <div className="row align-items-end mt-3">
                    <div className="col text-left">
                        <button className="btn btn-primary" onClick={this.beginSurvey.bind(this)}>{this.labels.button}</button>
                    </div>
                </div>
            </div>
        );
    }

    beginSurvey(evt) {
        evt.target.disabled = true;

        this.props.onPageSuccess();
    }

    /**
     * Récupère le logo pour la langue sélectionnée. FR lorsqu'absent en anglais. Si aucun logo, retour false.
     */
    getLogoData() {
        let logoData = (this.props.lang === 'AN' && this.props.logo['AN'].type) ? this.props.logo['AN'] || {} : this.props.logo['FR'] || {};

        if (logoData.type && logoData.logo) {
            return logoData;
        } else {
            return false;
        }
    }

    /**
     * Affiche du bloc logo si nécessaire
     */
    renderLogo() {
        let logoData = this.getLogoData();

        if (logoData) {
            return (
                <div className="col-xs-12 col-lg-4 mb-3">
                    <img id="img-logo" src={`data:${logoData.type};base64,${logoData.logo}`} className="img-fluid" title={this.labels.altLogo} alt={this.labels.altLogo} />
                </div>
            );
        } else {
            return null;
        }
    }
}

Bienvenue.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired
}

Bienvenue.defaultProps = {
    lang: "FR"
}

export default Bienvenue